import Head from "next/head";

export function GlobalAnalyticsHeader() {
  return (
    <Head>
      {/* SeasonShare global google tag manager script */}
      <script
        async
        id={`ss-gtag-script1`}
        nonce={process.env.NEXT_PUBLIC_CSP_NONCE}
        src="https://www.googletagmanager.com/gtag/js?id=G-872Z567NZX"
      />
      <script
        id={`ss-gtag-script2`}
        nonce={process.env.NEXT_PUBLIC_CSP_NONCE}
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag() {
              dataLayer.push(arguments);
            }
            gtag('js', new Date());
            gtag('config', 'G-872Z567NZX');
          `,
        }}
      />
    </Head>
  );
}
